import * as yup from "yup";

const SchemaReleaseActions = (translate: Function) => yup.object().shape({
	intbb001: yup.array().of(yup.object().shape({
		inb001Efa005Id: yup.number().required(translate("Responsável é requerido")),
		inb001Efa005Id2: yup.number().required(translate("Autoridade é requerido")),
		inb001Dtinicio: yup.date().nullable().required(translate("Data Inicial é requerida")),
		inb001Dtfim: yup.date().nullable().required(translate("Data Final é requerida")).min(
			yup.ref("inb001Dtinicio"),
			translate("Data Final tem que ser após a Data Inicial")
		)
	}))
});

export default SchemaReleaseActions ;
